import { apiCall } from './gqlClient';

const TRAININGMICROCYCLES_QUERY = `
  query trainingMicrocycles($providerId: Float!) {
    trainingMicrocycles(providerId: $providerId)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const trainingMicrocyclesApiCall = async ({providerId}, fragments = null) => apiCall({ query: TRAININGMICROCYCLES_QUERY, variables: {providerId}, fragments });

const TRAININGMICROCYCLE_QUERY = `
  query trainingMicrocycle($id: String!) {
    trainingMicrocycle(id: $id)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const trainingMicrocycleApiCall = async ({id}, fragments = null) => apiCall({ query: TRAININGMICROCYCLE_QUERY, variables: {id}, fragments });

const CREATETRAININGMICROCYCLE_QUERY = `
  mutation createTrainingMicrocycle($input: TrainingMicrocycleInput!) {
    createTrainingMicrocycle(input: $input)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const createTrainingMicrocycleApiCall = async ({input}, fragments = null) => apiCall({ query: CREATETRAININGMICROCYCLE_QUERY, variables: {input}, fragments });

const UPDATETRAININGMICROCYCLE_QUERY = `
  mutation updateTrainingMicrocycle($id: String!, $input: TrainingMicrocycleInput!) {
    updateTrainingMicrocycle(id: $id, input: $input)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const updateTrainingMicrocycleApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATETRAININGMICROCYCLE_QUERY, variables: {id, input}, fragments });

const DELETETRAININGMICROCYCLE_QUERY = `
  mutation deleteTrainingMicrocycle($id: String!) {
    deleteTrainingMicrocycle(id: $id)
    {
      id
			providerId
			name
			description
			lengthDays
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const deleteTrainingMicrocycleApiCall = async ({id}, fragments = null) => apiCall({ query: DELETETRAININGMICROCYCLE_QUERY, variables: {id}, fragments });
